import * as React from 'react'
import * as classNames from 'classnames'

import * as Style from './style.css'

type InputType = 'text' | 'email' | 'password'

export interface IProps
  extends Omit<React.ComponentPropsWithoutRef<'input'>, 'type' | 'className'> {
  type?: InputType
  isError?: boolean
  isErrorAlert?: boolean
}

export const InputText = React.forwardRef<HTMLInputElement, IProps>(
  ({ type, isError, isErrorAlert, ...props }, ref) => (
    <input
      type={type || 'text'}
      className={classNames({
        [Style.InputText]: true,
        [Style.InputTextError]: isError,
        [Style.InputTextErrorAlert]: isErrorAlert,
      })}
      {...props}
      ref={ref}
    />
  ),
)
